import { Toast } from './components/ui/toast.js';
import { eventBus } from './events.js';

class NotificationManager {
    constructor() {
        this._permission = typeof Notification !== 'undefined' ? Notification.permission : 'default';
    }

    get supported() {
        return 'Notification' in window && 'serviceWorker' in navigator;
    }

    get permitted() {
        return this._permission === 'granted';
    }

    async requestPermission() {
        if (!this.supported) return false;
        if (this._permission === 'granted') return true;
        if (this._permission === 'denied') return false;

        this._permission = await Notification.requestPermission();
        return this._permission === 'granted';
    }

    /**
     * Subscribe to push notifications via service worker.
     * @param {string} vapidPublicKey - VAPID public key from server
     */
    async subscribePush(vapidPublicKey) {
        if (!this.permitted) {
            const ok = await this.requestPermission();
            if (!ok) return null;
        }

        try {
            const reg = await navigator.serviceWorker.ready;
            let sub = await reg.pushManager.getSubscription();

            if (!sub) {
                sub = await reg.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: this._urlBase64ToUint8Array(vapidPublicKey),
                });
            }

            return sub.toJSON();
        } catch {
            return null;
        }
    }

    /**
     * Handle incoming push messages from service worker.
     */
    initServiceWorkerListener() {
        if (!('serviceWorker' in navigator)) return;

        navigator.serviceWorker.addEventListener('message', (event) => {
            const { type, data } = event.data || {};

            if (type === 'push-notification') {
                Toast.info(data.body || data.title || 'Новое уведомление');
                eventBus.emit('notification:received', data);
            }

            if (type === 'notification-click') {
                eventBus.emit('notification:click', data);
                if (data.url) {
                    window.location.hash = data.url;
                }
            }
        });
    }

    _urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
        const raw = atob(base64);
        const arr = new Uint8Array(raw.length);
        for (let i = 0; i < raw.length; i++) {
            arr[i] = raw.charCodeAt(i);
        }
        return arr;
    }
}

export const notifications = new NotificationManager();
